// extracted by mini-css-extract-plugin
module.exports = {"button":"OddsBtn_button__rDYoH","handicap":"OddsBtn_handicap__V7TYC","odds":"OddsBtn_odds__iW_x7"};